import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class OpenNewProjectDialogCommand extends AbstractCommand<void> {

    public name: CommandName = CommandName.OPEN_NEW_PROJECT_DIALOG;

    public tags = ['ui', 'dialog', 'project', 'create'];

    constructor() {
        super('project', 'new', undefined);
    }
}